import React from "react";
import SessaoJitsi from "../Jitsi/SessaoJitsi";

const JitsiMeeting = () => {
    return <SessaoJitsi />;
};

export default JitsiMeeting;
